import { useFormContext, useWatch } from 'react-hook-form';
import FormTextarea from 'components/common/forms/FormTextarea';
import LabelInput from 'components/common/forms/LabelInput';
import EvaluationDetail from 'pages/modal/EvaluationDetail';
import classNames from 'classnames';
import styles from 'styles/components/pages/chart/ChartFeedback.module.scss';
import { EvaluationChartFeedbackFormField } from 'types/form/evaluationChart';
import useModal from 'hooks/useModal';

type TProps = {
  isProfessor: boolean;
  evaluationChartId: number;
  userId: number;
  feedbackId: number;
  handleFocus?: () => void;
};

const ChartFeedback = ({
  isProfessor,
  evaluationChartId,
  userId,
  feedbackId,
  handleFocus,
}: TProps) => {
  const { openModal } = useModal();
  const { control } = useFormContext();
  const score = useWatch({
    name: EvaluationChartFeedbackFormField.Score,
    control,
  });

  const getScoreText = (score: number | null) => {
    if (!score && score !== 0) return '점수를 입력해주세요';
    if (score < 0 || score > 100)
      return '점수는 0점 이상, 100점 이하여야 합니다';
    if (score >= 0 && score <= 20) return '"매우 낮음"에 해당 되는 점수입니다.';
    if (score >= 21 && score <= 40) return '"낮음"에 해당 되는 점수입니다.';
    if (score >= 41 && score <= 60) return '"보통"에 해당 되는 점수입니다.';
    if (score >= 61 && score <= 80) return '"우수"에 해당 되는 점수입니다.';
    if (score >= 81 && score <= 100)
      return '"매우 우수"에 해당 되는 점수입니다.';
    return '';
  };

  return (
    <div>
      <div className={styles.title_wrapper}>
        <h1 className={styles.title}>차트 평가하기</h1>
        <button
          className={classNames(styles.btn, 'excluded2')}
          type="button"
          onClick={() =>
            openModal({
              element: (
                <EvaluationDetail
                  isProfessor={isProfessor}
                  evaluationChartId={evaluationChartId}
                  userId={userId}
                  feedbackId={feedbackId}
                />
              ),
            })
          }
        >
          평가 이력 보기
        </button>
      </div>
      <div className={styles.score_wrapper}>
        <LabelInput
          labelText="점수"
          placeholderText="해당 학생의 점수를 입력해 주세요."
          name={EvaluationChartFeedbackFormField.Score}
          inputStyle={{ width: '300px', fontSize: '16px' }}
          inputType="number"
          rules={{
            required: '점수를 입력해 주세요.',
            min: {
              value: 0,
              message: '0 이상의 점수를 입력해 주세요.',
            },
            max: {
              value: 100,
              message: '100 이하의 점수를 입력해 주세요.',
            },
          }}
          readOnly={!isProfessor}
          handleFocus={handleFocus}
        />
        <div className={styles.sub_text}>{getScoreText(score)}</div>
      </div>

      <div className={styles.feedback_wrapper}>
        <span className="fw700">피드백</span>
        <FormTextarea
          name={EvaluationChartFeedbackFormField.FeedbackContent}
          placeholder="해당 차트에 대한 피드백을 작성해 주세요."
          textareaStyle={{
            width: '100%',
            height: '320px',
            borderRadius: '8px',
            marginTop: '8px',
            padding: '10px 24px',
            fontSize: '16px',
            lineHeight: '24px',
          }}
          readOnly={!isProfessor}
        />
      </div>
    </div>
  );
};

export default ChartFeedback;
